export default __webpack_public_path__ + "static/media/PE.91633d4a.svg";